import { useEffect } from 'react';
import { useOrganization, useOrganizationList } from '@clerk/clerk-react';

/**
 * Automatically sets the active organization if user has one but none is active.
 * This ensures the JWT token includes org_id claim.
 */
export function OrganizationInitializer({ children }: { children: React.ReactNode }) {
  const { organization } = useOrganization();
  const { isLoaded, setActive, userMemberships } = useOrganizationList({
    userMemberships: {
      infinite: true,
    },
  });

  useEffect(() => {
    // Wait for data to load
    if (!isLoaded) return;

    // If user already has an active org, nothing to do
    if (organization) return;

    // If user has at least one org membership, activate the first one
    if (userMemberships?.data && userMemberships.data.length > 0) {
      const firstOrg = userMemberships.data[0].organization;
      console.log('Auto-activating organization:', firstOrg.name);
      setActive({ organization: firstOrg.id });
    }
  }, [isLoaded, organization, userMemberships, setActive]);

  return <>{children}</>;
}
